import { render, staticRenderFns } from "./UnionScheduleInfo.vue?vue&type=template&id=70fb1d67&scoped=true&"
import script from "./UnionScheduleInfo.vue?vue&type=script&lang=js&"
export * from "./UnionScheduleInfo.vue?vue&type=script&lang=js&"
import style0 from "./UnionScheduleInfo.vue?vue&type=style&index=0&id=70fb1d67&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70fb1d67",
  null
  
)

export default component.exports